<template>
	<div>
		<el-container>
			<el-aside class="navbar" style="height: 100% !important;">
				<NavBarLeft :list="navList"></NavBarLeft>
			</el-aside>
			<el-container class="right-main" style=" height: 100% !important;">
				<el-header class="header" style="padding: 0 !important;">
					<Header :list="navList"></Header>
				</el-header>
				<el-main class="main" style="padding: 0 !important;">
					<router-view :key="$route.fullPath" />
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>
<script>
import Header from '@/components/Header.vue'
import NavBarLeft from '@/components/Navbar.vue'
export default {
	name: 'home',
	data() {
		return {
			navList: [
        {
          id: 29,
          title: '数据统计',
          name: 'tj',
          path: '/tj/douyin',
        },
				{
					id: 1,
					title: '企业信息',
					// icon: require('../assets/image/icon1.png'),
					name: 'binhang',
					path: '',
					has_child: 1,
					page: [
						{
							title: '轮播图',
							path: '/qifu/carousel',
							id: 3,
							breadcrumb_father: '企业信息'
						},
						{
							title: '企业信息',
							path: '/manage/binhang',
							id: 28,
							breadcrumb_father: '企业信息'
						},
						{
							title: '关于我们',
							path: '/info/about',
							id: 10,
							breadcrumb_father: '企业信息'
						},
					],
				},
        {
          id: 30,
          title: '企业官网',
          name: 'official',
          path: 'official',
          has_child: 1,
          page: [
            {
              title: '业务体系',
              path: '/binhang/business',
              id: 31,
              breadcrumb_father: '企业官网'
            },
            {
              title: '客户案例',
              path: '/binhang/cases',
              id: 32,
              breadcrumb_father: '企业官网'
            },
            {
              title: '服务中心',
              path: '/binhang/service',
              id: 33,
              breadcrumb_father: '企业官网'
            },
            {
              title: '生态联盟',
              path: '/binhang/alliance',
              id: 34,
              breadcrumb_father: '企业官网'
            },
            {
              title: '关于企业',
              path: '/binhang/about',
              id: 35,
              breadcrumb_father: '企业官网'
            },
          ],
        },
				{
					id: 2,
					title: '企服管理',
					name: 'qifu',
					path: '/qifu/service',
				},
				{
					id: 5,
					title: '招商管理',
					// icon: require('../assets/image/icon1.png'),
					name: 'merchant',
					path: '/manage/merchant',
				},
				{
					id: 6,
					title: '咨讯管理',
					name: 'info',
					path: 'info',
					has_child: 1,
					page: [
						{
							title: '活动管理',
							path: '/info/activity',
							id: 7,
							breadcrumb_father: '咨讯管理'
						},
						// {
						// 	title: '活动回顾',
						// 	path: '/info/review',
						// 	id: 8,
						// 	breadcrumb_father:'咨讯管理'
						// },
						{
							title: '公开课',
							path: '/info/lesson',
							id: 9,
							breadcrumb_father: '咨讯管理'
						},
						{
							title: '问答管理',
							path: '/info/question',
							id: 11,
							breadcrumb_father: '咨讯管理'
						},
						{
							title: '官网咨讯',
							path: '/info/message',
							id: 12,
							breadcrumb_father: '咨讯管理'
						},
					]
				},
				{
					id: 13,
					title: '积分管理',
					name: 'score',
					path: 'score',
					has_child: 1,
					page: [
						{
							title: '优惠卷列表',
							path: '/score/coupon',
							id: 14,
							breadcrumb_father: '积分管理'
						},
						// {
						// 	title: '兑换情况',
						// 	path: '/score/situation',
						// 	id: 15,
						// 	breadcrumb_father:'积分管理'
						// }
					]
				},
				{
					id: 16,
					title: '客户服务',
					name: 'user',
					path: ' ',
					has_child: 1,
					page: [
						{
							title: '客户列表',
							path: '/person/customer',
							id: 17,
							breadcrumb_father: '客户服务'
						},
						{
							title: '活动客户',
							path: '/person/customerActive',
							id: 27,
							breadcrumb_father: '客户服务'
						},
						{
							title: '客服列表',
							path: '/person/customerService',
							id: 18,
							breadcrumb_father: '客户服务'
						},
						{
							title: '反馈列表',
							path: '/person/feedback',
							id: 20,
							breadcrumb_father: '客户服务'
						},
						// {
						// 	title: '分享列表',
						// 	path: '/person/share',
						// 	id: 21,
						// 	breadcrumb_father:'客户服务'
						// },
						// {
						// 	title: '图片分享',
						// 	path: '/person/photoshare',
						// 	id: 22,
						// 	breadcrumb_father:'客户服务'
						// },
						{
							title: '官网客户',
							path: '/info/userinfo',
							id: 27,
							breadcrumb_father: '客户服务'
						}
					]
				},
				{
					id: 26,
					title: '个人中心',
					name: 'personal',
					path: '/personal',
				},
				{
					id: 23,
					title: '系统管理',
					name: 'system',
					path: 'system',
					has_child: 1,
					page: [
						{
							title: '成员管理',
							path: '/system/mumber',
							id: 24,
							breadcrumb_father: '系统管理'
						},
						{
							title: '网站记录',
							path: '/system/history',
							id: 25,
							breadcrumb_father: '系统管理'
						},
					]
				},
			]
		}
	},
	components: {
		NavBarLeft,
		Header
	},
	mounted() {
	},
	methods: {

	}
}

</script>

<style lang="scss">
.navbar {
	height: 100vh;
	width: auto !important;

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		// width: 80px;
		width: 220px;
	}

	.el-menu--collapse {
		width: auto !important;
	}

	.right-main {
		width: calc(1920px - 220px);

		.el-header {
			padding: 0 20px;
		}

		.header {
			height: 60px;
			box-sizing: border-box;
			padding: 0 !important;
		}

		.main {
			padding: 0 !important;
			height: calc(100% - 60px) !important;
		}

	}

	.el-aside {
		transition: width 0.15s;
		-webkit-transition: width 0.15s;
		-moz-transition: width 0.15s;
		-webkit-transition: width 0.15s;
		-o-transition: width 0.15s;
	}

	.is-opened {
		display: block;
		background: white !important;
	}
}

.el-main {
	height: calc(100vh - 60px); //181px为顶部header高度+底部footer高度
	overflow-y: auto;
}

.el-aside::-webkit-scrollbar {
	display: none;
}



.hover-tip.el-tooltip__popper.is-light {
	background: #FFFFFF;
	border-radius: 5px 5px 5px 5px;
	box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
	border: none;

	.t-tip {
		font-size: 12px;
		font-weight: 400;
		color: #4D535C;
		line-height: 12px;
	}

	.t-example {
		font-size: 12px;
		font-weight: 400;
		color: #9A9EAA;
		line-height: 12px;
		margin-top: 12px;
	}
}
</style>
